import { logger } from '@/lib/logging'
import type { ScreenShareContext } from './screenShareTypes'
import { closeAudioMixing, restoreCameraFeed, stopTracks } from './streamHelpers'

export async function stopScreenSharingFlow({
  refs,
  isScreenSharing,
  setIsScreenSharing,
  showNotification,
}: ScreenShareContext) {
  if (!isScreenSharing) return

  if (refs.frameIntervalRef.current) {
    clearInterval(refs.frameIntervalRef.current)
    refs.frameIntervalRef.current = null
  }

  stopTracks(refs.screenStreamRef.current)
  refs.screenStreamRef.current = null

  if (refs.serviceRef.current && refs.mediaStreamRef.current) {
    refs.serviceRef.current.replaceInput(refs.mediaStreamRef.current)
  }

  await closeAudioMixing(refs)
  await restoreCameraFeed(refs)

  if (refs.recordingManagerRef.current && refs.mediaStreamRef.current) {
    try {
      refs.recordingManagerRef.current.updateMicrophoneStream(refs.mediaStreamRef.current)
      await refs.recordingManagerRef.current.switchVideoSource(refs.mediaStreamRef.current, true)
    } catch (err) {
      logger.error('Failed to restore recording to camera', { error: String(err) })
    }
  }

  setIsScreenSharing(false)
  refs.isScreenSharingRef.current = false

  if (refs.serviceRef.current) {
    refs.serviceRef.current.setScreenSharing(false)
    logger.info('AI notified that screen sharing has ended')
  }

  showNotification('Screen sharing ended - AI resumed')
}
